/*
 *
 *  * Copyright (c) 2018-2019 AccelByte Inc. All Rights Reserved.
 *  * This is licensed software from AccelByte Inc, for limitations
 *  * and restrictions contact your company contract manager.
 *
 */

import { default as React } from "react";
import { default as classNames } from "classnames";
import { components as ReactSelectComponents, default as ReactSelect } from "react-select";
import { SelectComponentsProps } from "react-select/lib/Select";
import InputLabel from "../InputLabel/InputLabel";
import { default as Styles } from "./Select.module.scss";
import InputErrorMessage from "../InputErrorMessage/input-error-message";
import { qaProps } from "../../../utils/qa";
import { CommonLocators } from "../CommonLocators";

interface Props extends SelectComponentsProps {
  label?: string;
  errorMessage?: string | null;
  isInvalid?: boolean;
  dataQa?: string | null;
}

const CustomDropdownIndicator = (props: any) => {
  return (
    // @ts-ignore
    <ReactSelectComponents.DropdownIndicator {...props}>
      <i className="icon icon-ab-down" />
    </ReactSelectComponents.DropdownIndicator>
  );
};

const CustomOption = (props: any) => {
  return (
    <div data-qa-props={qaProps(`value:${props.data.value}`)}>
      <ReactSelectComponents.Option {...props} />
    </div>
  );
};

const Select = ({ label, errorMessage, isInvalid, dataQa, ...props }: Props) => {
  return (
    <div className={classNames(Styles.selectContainer, { [Styles.error]: isInvalid })} data-qa-id={dataQa}>
      {label && <InputLabel text={label} />}
      <ReactSelect
        {...props}
        components={{ DropdownIndicator: CustomDropdownIndicator, Option: CustomOption }}
        className="react-select-container"
        classNamePrefix="react-select"
      />
      {isInvalid && errorMessage && <InputErrorMessage errorMessage={errorMessage} />}
    </div>
  );
};

export default Select;
